import React from 'react';
import Link from 'next/link';
import { useTranslation } from 'react-i18next';
import { isYearReviewSeason } from '../../shared/utils/year-review';
import { ROUTE_YEAR_REVIEW } from '../../shared/variables/routes';

/** LG-68: "Tenis Yılın" duyurusu; yalnız 1 Aralık–31 Ocak (İstanbul) ve oturum açmış oyuncuya. */
export default function YearReviewPromo() {
  const { t } = useTranslation('home');
  const season = isYearReviewSeason();
  if (!season.open) return null;
  return (
    <Link href={ROUTE_YEAR_REVIEW} passHref>
      <a className="year-review-promo">
        <span className="year-review-promo__year" aria-hidden="true">
          {season.year}
        </span>
        <span className="year-review-promo__body">
          <strong>{t('yearReview.promoTitle', { year: season.year })}</strong>
          <span>{t('yearReview.promoText')}</span>
        </span>
        <span className="year-review-promo__cta">{t('yearReview.promoAction')}</span>
      </a>
    </Link>
  );
}
